// extracted by mini-css-extract-plugin
export default {"locationMobile":"hotelCardLocation-module__locationMobile__hqAze","locationDesktop":"hotelCardLocation-module__locationDesktop__A6M4m"};